<template>
  <GenericListSubHeader :text="date" :previewable="false" :showCheckbox="false" :isChecked="false" color="primary" dark
    :toggleCheckbox="() => toggleSelected()" @PrimaryClick="toggleHideBy()">
    <v-row no-gutters align="center">
      <v-col class="px-3" cols="0">
        {{ date }}
      </v-col>
      <v-col cols="auto">
        <v-btn icon class="mx-1" @click.stop="toggleHideBy()">
          <v-icon v-text="!hideBy(date) ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </GenericListSubHeader>
</template>


<script>
import GenericListSubHeader from "@/components/ListItems/GenericListSubHeader.vue";

export default {
  name: 'DateSubHeader',
  props: {
    date: [Date, String],
    items: Array,
    selectionFilter: {
      type: Object,
      required: true
    },
    setSelectionFilterFunc: {
      type: Function,
      required: true
    }
  },
  components: {
    GenericListSubHeader,
  },

  data() {
    return {};
  },

  methods: {
    toggleHideBy() {
      var copy = Object.assign({}, this.selectionFilter);
      var hideBy = Object.assign({}, copy.hideBy);
      hideBy[this.date] = !hideBy[this.date];
      copy.hideBy = hideBy;
      this.setSelectionFilterFunc(copy);
      this.$emit('checkScroll'); //check scroll in case the list now is smaller than viewport
    },

    hideBy(date) {
      return this.selectionFilter.hideBy?.[date] ?? false;
    },
  },

  computed: {

  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>